import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';

import { AboutPage } from '../pages/about/about';
import { HomePage } from '../pages/home/home';
import { FoneCpfPage } from '../pages/fonecpf/fonecpf';
import { LoginWebPage } from '../pages/login-web/login-web';
import { InicialPage } from '../pages/inicial/inicial';
import { ConversaContatoPage } from '../pages/conversa-contato/conversa-contato';
import { NavegadorPage } from '../pages/navegador/navegador';
import { DenunciaListaPage } from '../pages/denuncialista/denuncialista';
import { DenunciaRegistroPage } from '../pages/denunciaregistro/denunciaregistro';
import { DenunciaDetalhesPage } from '../pages/denunciadetalhes/denunciadetalhes';
import { AdicionarContatoPage } from '../pages/adicionar-contato/adicionar-contato';
import { ConversaPageWatson } from '../pages/conversaWatson/conversa';
import { ImagemGedPage } from '../pages/imagem-ged/imagem-ged';
import { ConversaAreaPage } from '../pages/conversa-area/conversa-area';

import { BrComDao } from '../service/BrComDao'
import { BrComService } from '../service/BrComService'
import { RemoteService } from '../service/RemoteService'
import { IniciaPaginaService } from '../service/IniciaPaginaService';
import { PushService } from '../service/PushService';
import { Camera } from '@ionic-native/camera';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { UniqueDeviceID } from '@ionic-native/unique-device-id';
import { Push } from '@ionic-native/push';
import { BrowserTab } from '@ionic-native/browser-tab';
import { Device } from '@ionic-native/device';
import { AppVersion } from '@ionic-native/app-version';
import { SocialSharing } from '@ionic-native/social-sharing';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { AppAvailability } from '@ionic-native/app-availability';
import { FileTransfer } from '@ionic-native/file-transfer';
import { Geolocation } from '@ionic-native/geolocation';
import { NativeGeocoder } from '@ionic-native/native-geocoder';

import { ElasticModule } from 'ng-elastic';

import { Network } from '@ionic-native/network';

import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireModule } from '@angular/fire';

import { ComponentsModule } from '../components/components.module';
import { HTTP } from '@ionic-native/http';
import { SpeechRecognition } from '@ionic-native/speech-recognition';
import { DatePipe } from '@angular/common';
import { FotoProvider } from '../providers/foto/foto';
import { HttpClientModule } from '@angular/common/http';
import { File } from '@ionic-native/file';

import { AndroidPermissions } from '@ionic-native/android-permissions';
import { FilePath } from '@ionic-native/file-path';
import { EmpresaProvider } from '../providers/empresa/empresa';
import { UsuarioProvider } from '../providers/usuario/usuario';
import { AuthProvider } from '../providers/auth/auth';
import { ContatoProvider } from '../providers/contato/contato';
import { ContatoLocalProvider } from '../providers/contato-local/contato-local';
import { MensagemProvider } from '../providers/mensagem/mensagem';
import { AreaProvider } from '../providers/area/area';
import { AreaLocalProvider } from '../providers/area-local/area-local';
import { ServidorProvider } from '../providers/servidor/servidor';
import { FcmProvider } from '../providers/fcm/fcm'

import { BrMaskerModule } from 'brmasker-ionic-3';
import { EmpresaLocalProvider } from '../providers/empresa-local/empresa-local';
import { AuthWebProvider } from '../providers/auth-web/auth-web';

import { IonicImageLoader } from 'ionic-image-loader';

import { PipesModule } from '../pipes/pipes.module';

//trocar quando gerar nova versão


export const firebaseConfig = {
    apiKey: "AIzaSyBVigJNfIV4pKTvQsaKbR3SCI3CLF2kitg",
    authDomain: "lideranca-12739.firebaseapp.com",
    databaseURL: "https://lideranca-12739.firebaseio.com",
    projectId: "lideranca-12739",
    storageBucket: "lideranca-12739.appspot.com",
    messagingSenderId: "698895241678",
    appId: "1:698895241678:web:4f61f0a715372c7f"
};
/*
export const firebaseConfig = {
  apiKey: "AIzaSyDG7r3D8AubCEg9IjB9WqSiYUQfLOXnXz0",
  authDomain: "aprasc-2731f.firebaseapp.com",
  databaseURL: "https://aprasc-2731f.firebaseio.com",
  projectId: "aprasc-2731f",
  storageBucket: "aprasc-2731f.appspot.com",
  messagingSenderId: "79247676288",
  appId: "1:79247676288:web:c11573b5ef29932da86765"
};*/

/*export const firebaseConfig = {
  apiKey: "AIzaSyDlVEvSVHInWrh7klECq49wKbjKEeFolBs",
  authDomain: "sindprevssc3-1f98b.firebaseapp.com",
  databaseURL: "https://sindprevssc3-1f98b.firebaseio.com",
  projectId: "sindprevssc3-1f98b",
  storageBucket: "sindprevssc3-1f98b.appspot.com",
  messagingSenderId: "390058966203",
  appId: "1:390058966203:web:1be3367f5103b963"
}*/

/*
export const firebaseConfig = {
  apiKey: "AIzaSyBDsDg50soYL8s24mv34lk5I3oKdJcmpJI",
  authDomain: "brcomunique2.firebaseapp.com",
  databaseURL: "https://brcomunique2.firebaseio.com",
  projectId: "brcomunique2",
  storageBucket: "brcomunique2.appspot.com",
  messagingSenderId: "109453559228",
  appId: "1:109453559228:web:073cdf8b7b70e9cd15d7b9"
};*/

/*export const firebaseConfig = {
  apiKey: "AIzaSyBL1TaFMmvVvb_aJMSuI_Kvctb3hMzQABo",
  authDomain: "fenapef-d0bbc.firebaseapp.com",
  databaseURL: "https://fenapef-d0bbc.firebaseio.com",
  projectId: "fenapef-d0bbc",
  storageBucket: "fenapef-d0bbc.appspot.com",
  messagingSenderId: "699975495098",
  appId: "1:699975495098:web:a9165b65dea9c560e94183"
};*/


/*export const firebaseConfig = {
  apiKey: "AIzaSyAtdZO_od4Z69MqiNfKWrHvYjxfR-cv1Ws",
  authDomain: "caben-38fb3.firebaseapp.com",
  databaseURL: "https://caben-38fb3.firebaseio.com",
  projectId: "caben-38fb3",
  storageBucket: "caben-38fb3.appspot.com",
  messagingSenderId: "576691418561",
  appId: "1:576691418561:web:b542c6c5eeb40b20b76b40"
};*/

@NgModule({
  declarations: [
    MyApp,
    AboutPage,
    HomePage,
    FoneCpfPage,
    LoginWebPage,
    InicialPage,
    NavegadorPage,
    DenunciaListaPage,
    DenunciaRegistroPage,
    DenunciaDetalhesPage,
    ConversaPageWatson,
    ImagemGedPage,
    AdicionarContatoPage,
    ConversaContatoPage,
    ConversaAreaPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    IonicImageLoader.forRoot(),
    ElasticModule,
    AngularFireMessagingModule,
    // as mensagens usam um projeto e o upload de arquivo usam outro (mensagem.ts)
    // por isso é colocado o parametro do nome, para poder criar uma referencia para cada caso
    AngularFireModule.initializeApp(firebaseConfig, "lideranca"),
    AngularFireStorageModule,
    AngularFirestoreModule,
    ComponentsModule,
    HttpClientModule,
    BrMaskerModule,
    PipesModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    AboutPage,
    HomePage,
    FoneCpfPage,
    LoginWebPage,
    InicialPage,
    NavegadorPage,
    DenunciaListaPage,
    DenunciaRegistroPage,
    DenunciaDetalhesPage,
    ConversaPageWatson,
    ImagemGedPage,
    AdicionarContatoPage,
    ConversaContatoPage,
    ConversaAreaPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    UniqueDeviceID,
    Push,
    Device,
    BrComDao,
    BrComService,
    RemoteService,
    IniciaPaginaService,
    PushService,
    BrowserTab,
    AppVersion,
    SocialSharing,
    Camera,
    InAppBrowser,
    AppAvailability,
    FileTransfer,
    Geolocation,
    NativeGeocoder,
    Network,
    HTTP,
    SpeechRecognition,
    DatePipe,
    FotoProvider,
    File,
    AndroidPermissions,
    FilePath,
    EmpresaProvider,
    UsuarioProvider,
    AuthProvider,
    ContatoProvider,
    ContatoLocalProvider,
    MensagemProvider,
    AreaProvider,
    AreaLocalProvider,
    ServidorProvider,
    EmpresaLocalProvider,
    FcmProvider,
    AuthWebProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts